import { buttonTheme as Button } from './button';
import { badgeTheme as Badge } from './badge';

export const components = {
  Badge,
  Button,
};
